// extracted by mini-css-extract-plugin
module.exports = {"main":"AccountRegistrationCompleteNotify__main--127et"};